module.exports = __webpack_public_path__ + "static/media/feature-1.62574fa5.png";